const isPhone = value => {
  const cleanedValue = value.replace(/[^\d]/g, '') // Remove non-digit characters
  const isValid = cleanedValue.length >= 10

  if (!isValid) {
    return { isValid, message: 'Please enter a valid phone number with at least 10 digits.' }
  }
  return { isValid, message: '' }
}

export default isPhone
